import style from "./style.scss";
import { mergeClasses } from "../helpers";

const LargeViewOnly = ({ class: className = null, children, ...props }) => {
  const mergedClass = mergeClasses([style.largeViewOnly, className]);

  return (
    <div class={mergedClass} {...props}>
      {children}
    </div>
  );
};

export default LargeViewOnly;
